import React, {useEffect, useRef, useState} from "react";
import { useAuthentication } from "../../context/authentication";
import { useHistory } from "react-router-dom";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import{
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  Badge,
  Container,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Input
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NotificationsIcon from '@material-ui/icons/Notifications';
import {firebaseConfig} from '../../context/firebase'
import { MainListItems, SecondaryListItems } from '../../components/drawer';
import { User } from '../../database'
import AddUserForm from '../../components/addUserForm'
import ConfirmModal from '../../components/confirmDelete'
import './index.css'
import firebase from 'firebase'
import XLSX from 'xlsx';
import {processData, getCummulativeData, processTransactionData} from "../../utilities";
import {addBooks, addCummulativeEarnings, addTransactions} from "../../database/Book";



const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  addToUser:{
    marginBottom: 20
  }
}));
 const UsersScreen = () => {
  const { push } = useHistory();
  const [ users, setUsers ] = useState([]);
  const { doLogout } = useAuthentication();
  const [name, setName] = useState(null)
  const [phone, setPhone] = useState(null)
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [showUserModal, setShowUserModal] = useState(false)
  const [selectedUser, setSelectedUser]= useState(null)
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
  const [showError, setShowError] = useState(false);
  const uploadTransactionInputRef = useRef();
  const classes = useStyles();

  const [open, setOpen] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const logout = async () => {
    await doLogout();
    push("/login");
  };
  const resetState = () => {
     setName(null)
    setPhone(null)
    setSelectedUser(null)
  }
  useEffect(()=>{
    User.fetchUsers().then((result)=>{
      setUsers(result.data)
    })
  },[])

  const onChange = (e)=>{
    console.log(e.target.id)
    if(e.target.id === 'name'){
      setName(e.target.value)
    }
    if(e.target.id === 'email'){
      setEmail(e.target.value)
    }

    if(e.target.id === 'phone'){
      setPhone(e.target.value)
    }
    if(e.target.id === 'password'){
      setPassword(e.target.value)
    }
    if(e.target.id === 'confirm-password'){
      setConfirmPassword(e.target.value)
    }
  }
  const addUser = async () => {

    if(name && phone && email) {
      const user = {
        name,
        phone,
        email,
        updated_at:firebase.firestore.Timestamp.now(),
      }

      if(selectedUser) {
        const result = await User.updateUser({...user, id:selectedUser});
        if(result.data) {
          const newUser = users.map((item) => {
            if(item.id === selectedUser){
              return {...item, name:user.name,email:user.email, phone:user.phone, updated_at:user.updated_at}
            }else{
              return item
            }
          })
          setUsers(newUser)
          resetState()
          setShowUserModal(false);
          setShowError(false)

        }
      }else{
          const result = await User.addUser({...user, created_at:firebase.firestore.Timestamp.now()});
          if(result.data){
            const  secondaryApp = firebase.initializeApp(firebaseConfig, "secondary");
            const data = secondaryApp.auth().createUserWithEmailAndPassword(email, password);
            if(data){
              await secondaryApp.auth().signOut();
              await  secondaryApp.delete();
            }
            setUsers([result.data, ...users ])
            closeUserModal();
            setShowError(false)

          }else{
            console.log(result.e)
            alert('something went wrong')
          }
      }
  } else {
    setShowError(true)
  }
}

  const closeUserModal = () => {
    resetState()
    setShowUserModal(false)
  }
  const onEdit = (user) => {
    setName(user.name)
    setPhone(user.phone)
    setSelectedUser(user.id)
    setEmail(user.email)
    setShowUserModal(true)
  }

  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false)
  }
  const deleteUser = async () => {
    const result = await User.deleteUser(selectedUser)
    if(result.data){
      const newUsers = users.filter((item) => {
        return item.id !== selectedUser
      })
      resetState()
      setUsers(newUsers)
      closeConfirmModal()
    }
  }
  const readFile = (file) => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      /* Parse data */
      const ab = e.target.result;
      const wb = XLSX.read(ab, {type:'array'});
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, {header:1});
      /* Update state */
      const cummulativeData = getCummulativeData([...data]);
      const processedData  = processData([...data]);
      const response = await addBooks(processedData);
      const response1 = await addCummulativeEarnings(cummulativeData);
      if(response.data && response1.data){
        alert('added data');
      }else {
        console.log(response1.isError)
        console.log(response.isError)
      }
    };
    reader.readAsArrayBuffer(file);
  }
  const handleUploadTransaction = (e) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(e.target.files[0]);

    reader.onload = async (e) => {
      /* Parse data */
      const ab = e.target.result;
      const wb = XLSX.read(ab, {type:'array'});
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, {header:1});
     const transactions =  processTransactionData(data)
      const response = await addTransactions(transactions);
      if(response.data){
        alert('added data');
      }else {
        console.log(response.isError)
      }
    };
  }
  return (
    <div className={classes.root}>
    <CssBaseline />
    <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
        >
          <MenuIcon />
        </IconButton>
        <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
          Dashboard
        </Typography>
      </Toolbar>
    </AppBar>
    <Drawer
      variant="permanent"
      classes={{
        paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
      }}
      open={open}
    >
      <div className={classes.toolbarIcon}>
        <IconButton onClick={handleDrawerClose}>
          <ChevronLeftIcon />
        </IconButton>
      </div>
      <Divider />
      <List><SecondaryListItems logout={logout}/></List>
    </Drawer>
    <main className={classes.content}>
      <div className={classes.appBarSpacer} />
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={3}>
        <Button
          variant="contained"
          color="primary"
          onClick={()=>setShowUserModal(true)}
          className={classes.addToUser}>
          Add User
        </Button>
          <input
              className={classes.input}
              id="contained-button-file"
              multiple
              type="file"
              onChange={(e)=> readFile(e.target.files[0])}
          />
          <label htmlFor="contained-button-file">
            <Button variant="contained" color="primary" component="span" style={{marginLeft: '10px'}}>
              Upload
            </Button>
          </label>
          <Button
              style={{marginLeft: '20px'}}
              variant="contained"
              color="primary"
              onClick={()=>uploadTransactionInputRef.current.click()}
              className={classes.addToUser}>
            Upload transaction
          </Button>
          <input onChange={handleUploadTransaction} hidden type="file" ref={uploadTransactionInputRef} />
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Index</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Phone</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{index+1}</TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.phone}</TableCell>
                  <TableCell>
                    <Button
                    onClick={()=> onEdit(row)}
                    variant="contained" color="primary" style={{marginRight:'10px'}}>
                      Edit
                    </Button>
                    <Button
                    variant="contained"
                    color="secondary"
                    onClick={()=> {
                      setSelectedUser(row.id)
                      setIsConfirmModalOpen(true)
                    }}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
      </TableContainer>
        </Grid>
      </Container>
      <AddUserForm
        onChange={onChange}
        open={showUserModal}
        addUser={addUser}
        handleClose={closeUserModal}
        name={name}
        phone={phone}
        email={email}
        password={password}
        showError={showError}
        confirmPassword={confirmPassword}
      />
       <ConfirmModal
      open={isConfirmModalOpen}
      handleClose={closeConfirmModal}
      onSubmit={deleteUser}
      module='user'
      />

    </main>
  </div>
  );
};

export default UsersScreen
